<template>
  <div id="DeviceManagement_main">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            載具管理
          </div>
        </div>
      </div>
      <div class="cotent">
        <div
          class="thumbnail"
          @click="nfcOpen('open')"
        >
          <i
            class="icon-Link-ID"
            aria-hidden="true"
          />
          <div class="caption">
            綁定
          </div>
        </div>
        <div
          class="thumbnail"
          @click="nfcOpen('del')"
        >
          <i
            class="icon-Unlink-ID"
            aria-hidden="true"
          />
          <div class="caption">
            解除
          </div>
        </div>
      </div>
    </div>
    <reader
      ref="reader"
      :manual-input="false"
    />
  </div>
</template>
<script>
import ReadNFCBarcode from '@/components/ReadNFCBarcode'
export default {
  components: {
    reader: ReadNFCBarcode
  },
  data () {
    return {
    }
  },
  methods: {
    nfcOpen (type) {
      const vobj = this
      const account = JSON.parse(localStorage.getItem('loginUserInfo')).Account.replace('auth_', '')
      this.$refs.reader.getCode((code) => {
        sandAPI(code)
        function sandAPI (code) {
          const codeList = []
          let nowInd = 0
          if (typeof (code) === 'string') {
            codeList.push(code)
          } else {
            code.map(val => codeList.push(val))
          }
          if (codeList[nowInd].length < 5) {
            vobj.$alert('載具格式錯誤，請再次感應卡片', '警告', {
              confirmButtonText: '確認',
              type: 'warning',
              showClose: false,
              roundButton: true,
              closeOnClickModal: false,
              callback: action => {
                vobj.$refs.reader.resetInput()
              }
            })
            return false
          }
          API()
          function API () {
            console.log(`ind:${nowInd}`)

            if (type === 'open') {
              apiManagement.GetPostAuthorizationCarrierValidation({
                Code: codeList[nowInd]
              }).then(() => {
                vobj.$confirm(`請再次確認是否要將此載具加入帳號 ${account} ?`, '警告', {
                  confirmButtonText: '確認',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  apiManagement.PostAuthorizationCarrier({
                    Code: codeList[nowInd]
                  }).then(res => {
                    vobj.$message({ message: '卡片已綁定成功', type: 'success' })
                    nowInd++
                    if (nowInd <= codeList.length - 1) {
                      API()
                    } else {
                      vobj.$refs.reader.close()
                    }
                  }).catch(err => {
                    vobj.$notify.error({ title: '發生未知錯誤!!', message: this.$t('General.PleaseContactUs') })
                    if (nowInd <= codeList.length - 1) {
                      API()
                    } else {
                      vobj.$refs.reader.close()
                    }
                  })
                }).catch(() => {
                  vobj.$refs.reader.close()
                })
              }).catch(err => {
                console.log(err.response)
                if (err.response.data.ErrorMessage.Code === 400002) {
                  vobj.$alert(err.response.data.ErrorMessage.Description, '警告', {
                    confirmButtonText: '確認',
                    type: 'warning',
                    showClose: false,
                    roundButton: true,
                    closeOnClickModal: false,
                    callback: () => {
                      vobj.$refs.reader.close()
                    }
                  })
                } else {
                  vobj.$refs.reader.resetInput()
                }
              })
            } else {
              apiManagement.GetDeleteAuthorizationCarrierValidation({
                Code: codeList[nowInd]
              }).then(res => {
                if (res.data.Data) {
                  vobj.$confirm(`請再次確認是否要將此載具從帳號 ${account} 解除?`, '警告', {
                    confirmButtonText: '確認',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(() => {
                    apiManagement.DeleteAuthorizationCarrier({
                      Code: codeList[nowInd]
                    }).then(res => {
                      vobj.$message({ message: '卡片已解除', type: 'success' })
                      nowInd++
                      if (nowInd <= codeList.length - 1) {
                        API()
                      } else {
                        vobj.$refs.reader.close()
                      }
                    }).catch(err => {
                      vobj.$notify.error({ title: '發生未知錯誤!!', message: this.$t('General.PleaseContactUs') })
                      if (nowInd <= codeList.length - 1) {
                        API()
                      } else {
                        vobj.$refs.reader.close()
                      }
                    })
                  }).catch(() => {
                    vobj.$refs.reader.close()
                  })
                } else {
                  vobj.$alert('此卡片並未綁定於此社區管理人員帳號。', '警告', {
                    confirmButtonText: '確認',
                    type: 'warning',
                    showClose: false,
                    roundButton: true,
                    closeOnClickModal: false,
                    callback: () => {
                      vobj.$refs.reader.resetInput()
                    }
                  })
                }
              })
            }
          }
        }
      },
      'NFC'
      ) }
  }
}
</script>
<style lang="sass" scoped>
#DeviceManagement_main
  +mainLayer
  .cotent
    padding: 50px 0
    width: 490px
    margin: 0 auto
    display: flex
  .thumbnail
    padding-top: 45px
    padding-bottom: 20px
    width: 215px
    flex: 0 0 215px
    background-color: $white
    margin: 15px
    text-align: center
    align-items: center
    justify-content: center
    cursor: pointer
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.3)
    border-radius: $pageBorderRadius
    &:hover
      background-color: $mainColorHover
    i
      width: 100%
      height: 30%
      color: $mainColor
      font-size: 60px
    .caption
      display: block
      font-size: 30px
      color: #4B4B4B
      margin-top: 25px
    .tip
      display: block
      margin-top: 10px
      margin-bottom: 10px
</style>
